require('./index-style-only');

module.exports = require('./components');
